import { FC } from "react";

import { PropsType } from "../interfaces/ChildrenType";

export const combineComponents = (...components: FC<PropsType>[]): FC<PropsType> => {
  return components.reduce<FC<PropsType>>(
    (AccumulatedComponents, CurrentComponent) => {
      return ({ children }: PropsType): JSX.Element => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },

    ({ children }: PropsType) => <>{children}</>
  );
};
